import script from "./VLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./VLogin.vue?vue&type=script&setup=true&lang=js"

import "./VLogin.vue?vue&type=style&index=0&id=3d6fdf5a&lang=css"

const __exports__ = script;

export default __exports__